document.addEventListener('DOMContentLoaded', () => {
    const $ = jQuery;

    const is_homePage = document.body.classList.contains('home');
    if (is_homePage) {
        $('.intro-slides').slick({
            infinite: true,
            fade: true,
            arrows: true
        })
        // $('.testimonials-wrapper .content').slick({
        //     infinite: true,
        //     fade: true,
        //     arrows: false,
        //     dots: true,
        //     autoplay: true,
        //     autoplaySpeed: 4000
        // })
        $('.references-wrapper .content').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        })
    }

    /**
     * CPT PRESTATIONS
     */
    const is_prestation = document.body.classList.contains('single-prestation');
    if (is_prestation) {
        $('.section-slider-photo-texte .slider .slides').slick({
            infinite: true,
            fade: true,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 4000,
            appendArrows: $('.custom-arrows')
        })
    }
})